import React from "react";

export default function GraphicCalendarNotes({ calNotes, contCalNotes }) {
    return (
      <div className="Graphic-calendar-notes">
        {calNotes}
        {contCalNotes}
      </div>
  );
}
